import React from "react";
import { Select, MenuItem, FormHelperText } from "@mui/material";
import { useIntl } from "react-intl";
import { inputStyles } from "./styles/inputStyles";

const SelectMeetingType = ({
    selectedMeetingType,
    handleSelectChange,
    typeError,
    meetingTypes,
}) => {
    const intl = useIntl();
    return (
        <>
            <Select
                fullWidth
                labelId="meeting-type"
                label="Yolo"
                id="meeting-type-select"
                value={selectedMeetingType}
                variant="filled" // Changed from "outlined" to "filled"
                onChange={handleSelectChange}
                disableUnderline={false} // Keep the underline for filled style
                sx={{
                    ...inputStyles,

                    "&.MuiSelect-root": {
                        paddingLeft: "2px",
                        backgroundColor: "transparent", // Transparent background for the select field
                        "&:before": {
                            borderBottomColor: "gray",
                            borderBottomWidth: "0.5px", // Thinner default border
                            borderBottomStyle: "solid",
                            opacity: 1,
                        },
                        "&:after": {
                            borderBottomColor: "black",
                            borderBottomWidth: "1px", // Thinner focus border
                            borderBottomStyle: "solid",
                        },
                    },
                    // Target the label of the Select
                    "& .MuiInputLabel-root": {
                        paddingLeft: "12px", // Move label text to the right
                        position: "relative", // Set position to relative to control the transform
                        transform: "translateX(12px)", // Move the label to the right
                        "&.Mui-focused": {
                            transform: "translateX(12px)", // Keep the label shifted when focused
                        },
                    },
                }}
            >
                {meetingTypes
                    .filter(
                        (type) =>
                            type.is_client_meeting === true
                                ? type.is_client_meeting
                                : type.is_client_meeting === false
                                ? !type.is_client_meeting
                                : true // If null or undefined, show all meetings
                    )
                    .map((type) => (
                        <MenuItem
                            key={type.meeting_type_id}
                            value={type.meeting_type_id}
                        >
                            {type.description}
                        </MenuItem>
                    ))}
            </Select>

            {typeError && (
                <FormHelperText error={typeError}>
                    {intl.formatMessage({
                        id: "meetingModal.selectError",
                    })}
                </FormHelperText>
            )}
        </>
    );
};

export default SelectMeetingType;
